<template>
    <div class="container">
        <v-title :lineage="[{'Gateway Accounts':'gateway-accounts'}]">
            {{gatewayAccount.id}}
            <div slot="actions">
                <router-link
                    class="btn btn-primary" :to="{name: 'update-gateway-account', params: {id: id}}">
                    Edit Gateway Account
                </router-link>
            </div>
        </v-title>
        <div class="grid" v-if="!isLoading">
            <div class="grid-item grid-item-primary">
                <div class="grid">
                    <div class="grid-item grid-item-full">
                        <gateway-status
                            @update="updateStatus"
                            @update-timeline="updateTimeline"
                            :gateway="gatewayAccount"/>
                    </div>
                    <div class="grid-item grid-item-full">
                        <gateway-downtimes
                            @update-is-down="updateIsDown"
                            :gateway="gatewayAccount"/>
                    </div>
                    <div class="grid-item grid-item-full">
                        <timeline
                            ref="timeline"
                            type="gateway"
                            :key="`gateway-account-${gatewayAccount.id}-timeline`"
                            :entity="gatewayAccount"/>
                    </div>
                </div>
            </div>
            <div class="grid-item grid-item-secondary">
                <div class="grid">
                    <div class="grid-item grid-item-full">
                        <organization :gateway="gatewayAccount"/>
                    </div>
                    <div class="grid-item grid-item-full">
                        <accepted-currencies :gateway="gatewayAccount"/>
                    </div>
                    <div class="grid-item grid-item-full">
                        <payment-method :gateway="gatewayAccount"/>
                    </div>
                    <div v-if="gatewayAccount.hasAdditionalCriteria" class="grid-item grid-item-full">
                        <gateway-additional-criteria :gateway="gatewayAccount"/>
                    </div>
                    <div class="grid-item grid-item-full">
                        <additional-information :gateway="gatewayAccount"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import vTitle from '@/components/v-title';
    import {vIcon} from '@/components/form';
    import LoadStateMixin from '@/mixins/load-state-mixin';
    import GatewayAccountModel from '@/common/models/gateway-account-model';
    import Organization from '@/modules/gateway-accounts/components/details/organization';
    import GatewayStatus from './components/details/gateway-status';
    import GatewayDowntimes from './components/details/gateway-downtimes/gateway-downtimes';
    import AcceptedCurrencies from './components/details/accepted-currencies';
    import PaymentMethod from './components/details/payment-method';
    import GatewayAdditionalCriteria from './components/details/gateway-additional-criteria';
    import AdditionalInformation from './components/details/additional-information';

    export default {
        name: 'gateway-account-details',
        mixins: [LoadStateMixin],
        components: {
            vTitle,
            vIcon,
            GatewayStatus,
            GatewayDowntimes,
            Organization,
            AcceptedCurrencies,
            PaymentMethod,
            GatewayAdditionalCriteria,
            AdditionalInformation,
            Timeline: () => import('@/components/timeline/timeline.vue'),
        },
        props: {
            id: {
                type: [String, Number],
                default: null,
            },
        },
        data() {
            return {
                gatewayAccount: new GatewayAccountModel(),
                isLoading: true,
            };
        },
        methods: {
            async init() {
                this.startLoadingPage();
                this.isLoading = true;
                try {
                    const gatewayAccount = await this.$api(({gatewayAccounts}) => gatewayAccounts.get({
                        id: this.id,
                        expand: 'organization',
                    }));
                    this.gatewayAccount = new GatewayAccountModel(gatewayAccount.fields);
                } catch (error) {
                    this.$router.push({name: 'gateway-accounts'});
                } finally {
                    this.stopLoadingPage();
                    this.isLoading = false;
                }
            },
            // Todo: replace updateStatus and updateIsDown by storage based updates
            updateStatus({status}) {
                this.gatewayAccount.status = status;
            },
            updateIsDown({isDown}) {
                if (this.gatewayAccount.isDown !== isDown) {
                    this.updateTimeline();
                }
                this.gatewayAccount.isDown = isDown;
            },
            updateTimeline() {
                this.$refs.timeline.update();
            },
        },
        mounted() {
            this.init();
        },
    };
</script>
